import "@/index.css";
import "@/App.css";
import { CalculatorProvider, useCalculator } from "./context/CalculatorContext";
import { AuthProvider } from "./context/AuthContext";
import { Header } from "./components/Header";
import { HomeScreen } from "./components/HomeScreen";
import { GoogleAdsCalculator } from "./components/GoogleAdsCalculator";
import { MetaLeadsCalculator } from "./components/MetaLeadsCalculator";
import { MetaTrafficCalculator } from "./components/MetaTrafficCalculator";
import { Footer, AdminBadge } from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import { AnimatePresence, motion } from "framer-motion";

function CalculatorApp() {
  const { currentModule } = useCalculator();

  const renderModule = () => {
    switch (currentModule) {
      case 'google':
        return <GoogleAdsCalculator />;
      case 'meta_leads':
        return <MetaLeadsCalculator />;
      case 'meta_traffic':
        return <MetaTrafficCalculator />;
      default:
        return <HomeScreen />;
    }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col" data-testid="calculator-app">
      <Header />
      <AdminBadge />
      <AnimatePresence mode="wait">
        <motion.main
          key={currentModule || 'home'}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
          className="flex-1"
        >
          {renderModule()}
        </motion.main>
      </AnimatePresence>
      <Footer />
      <Toaster position="bottom-right" />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <CalculatorProvider>
        <CalculatorApp />
      </CalculatorProvider>
    </AuthProvider>
  );
}

export default App;
